import React, {useState, useEffect, useRef} from 'react';

import classNames from 'classnames';

import MotifButton from '@ey/motif-react-wrapper/Button';
import MotifProgressIndicator from '@ey/motif-react-wrapper/ProgressIndicator';
import MotifProgressIndicatorStep from '@ey/motif-react-wrapper/ProgressIndicatorStep'
import StyledProgressIndicator from './StyledProgressIndicator';

const ProgressIndicator = ({
	steps,
	currentStepIndex,
	stepContent,
	buttons,
	indicatorClasses = null,
	contentClasses = null,
	buttonsClasses = null,
	size = 'sm',
	variant = 'row'
}) => {
	const [activeIndex, setActiveIndex] = useState(
		currentStepIndex ? currentStepIndex : steps?.findIndex((e) => e.active)
	);
	const [nextStep, setNextStep] = useState(false);
	const [previousStep, setPreviousStep] = useState(false);

    const stepsClass = {
        className: classNames({[`${indicatorClasses}`]: !!indicatorClasses})
    };

    const bodyClass = {
        className: classNames('content-section customScrollbar', {[`${contentClasses}`]: !!contentClasses})
    };

    const footerClass = {
        className: classNames('buttons-section', {[`${buttonsClasses}`]: !!buttonsClasses})
    };


	const clickContinue = (e, data) => {
		let isValid = e;
		if (isValid) {
			if (steps[currentStepIndex].isExit) {
				clickExit && clickExit(data);
			} else {
				steps[currentStepIndex].active = false;
				setActiveIndex(currentStepIndex + 1);
				steps[currentStepIndex].active = true;
			}
		}
		setNextStep(false);
	};

	const clickBack = () => {
		if (currentStepIndex === 0) {
			clickCancel && clickCancel();
		} else {
			steps[currentStepIndex].active = false;
			setActiveIndex(currentStepIndex - 1);
			steps[currentStepIndex].active = true;
		}
		setPreviousStep(false);
	};

	const renderSteps = () => {
		let stepIndicator = steps?.map((step, i) => {
			return (
				<MotifProgressIndicatorStep
					status={currentStepIndex === i ? 'active' : currentStepIndex > i ? 'completed' : 'default'}
					heading={step?.stepName}
					body={step?.stepDescription}
				/>
			);
		});
		return stepIndicator;
	};

	const renderContent = () => {
		if (stepContent !== undefined) {
			return React.cloneElement(stepContent[currentStepIndex], {
				onNext: clickContinue,
				next: nextStep,
				onPrevious: clickBack,
				previous: previousStep
			});
		}
	};
	const renderButtons = () => {
		let btns = '';
		buttons && buttons.length > 0
			? (btns = buttons.map((button, i) => (
					<MotifButton
						onClick={button.onClick}
						variant={button.variant ? button.variant : button.isPrimary ? 'primary' : 'secondary'}
						disabled={button.disabled}
						title={button.title ? button.title : ''}
						size="medium"
					>
						{button.label}
					</MotifButton>
			  )))
			: (btns = (
					<></>
			  ));

		return <div className='buttons-content'>{btns}</div>;
	};

	return (
		<StyledProgressIndicator>
			<MotifProgressIndicator size={size} variant={variant} {...stepsClass}>
				{renderSteps()}
			</MotifProgressIndicator>
			<div {...bodyClass}>{renderContent()}</div>
			<div {...footerClass}>{renderButtons()}</div>
		</StyledProgressIndicator>
	);
};
export default ProgressIndicator;
